<div ng-controller="waitingReminderController as ctrl" class="modal-view">
    <c-auto-form config="ctrl.autoFormConfig"></c-auto-form>
</div>